import React, {useContext, useEffect, useState} from 'react';
import {FaPlus, FaTimes} from "react-icons/fa";
import DragDrop from "../outlet-components/DragDrop";
import UploaderRow from "../outlet-components/UploaderRow";
import {useParams} from "react-router-dom";
import {SectionsContext} from "../../contexts/SectionsProvider";
import {MortgageContext} from "../../contexts/MortgageProvider";
import OutletWrapper from "../outlet-components/OutletWrapper";

function Upload(props) {
    const params = useParams()
    const sectionsContext = useContext(SectionsContext)
    const mortgageContext = useContext(MortgageContext)
    const [state, setState] = useState({
        editing: false,
        viewing: false,
        contentType: false,
        files: {},
        position:'top'
    })
    const sectionName = props.applicant ? params.section + '-' + props.applicant : params.section
    const section = sectionsContext.sections.uploads.find(i => i.name === sectionName)

    const handleDrop = (files) => {
        addUploads(files);
    }
    const handleAdd = (event) => {
        addUploads(event.target.files);
    };

    const addUploads = async (filesObject) => {
        // clean out anything that's not a file
        const newFiles = Object.keys(filesObject).map((item, index) => {
            return filesObject[item]
        }).filter(file => {
            return !!file.name
        });
        // create a db item for each file
        const models = await sectionsContext.save.files(section, newFiles)
        const files = {}
        models.forEach((model, i) => {
            files[model.id] = newFiles[i]
        })
        setState((prev) => {
            prev.files = {...prev.files, ...files}
            return prev
        })
    }
    const onUploadComplete = (model) => {
        console.log('UPLOAD COMPLATED')
        const original = mortgageContext.mortgage.uploads.find(i => i.id === model.id)
        setState(prevState=>{
            delete(prevState.files[model.id])
            return prevState
        })
        sectionsContext.save.upload(original, {status: `PENDING`})
    }
    const cancelUpload = (cancel, token) => {
        //console.log(cancel);
        //console.log(token)
        if (typeof cancel === "function") {
            cancel()
            this.setState(function (prevState) {
                delete (prevState.files[token]);
                return {files: prevState.files}
            });
        }
    }
    const handleNameChange = (e) => {
        let model = mortgageContext.mortgage.uploads.find(u=>u.id === e.target.dataset.id)
        sectionsContext.save.upload(model,{fileName:e.target.value})
    }
    const handleDelete = (id) => {
        sectionsContext.delete.upload(id)
    }
    const toggleEdit = () => {
        setState(prevState => {
            return {...prevState, editing: !prevState.editing}
        })
    }
    const setViewing = (url, contentType) => {
        console.log(url, contentType)
        setState(prevState => {
            return {...prevState, viewing: url, contentType: contentType}
        })
    }
    const clearViewing = () => {
        setState(prevState=>{
            return {...prevState, viewing: false, contentType: false}
        })
    }
    useEffect(()=>{
        setState(prev=>{
            return {...prev, position:''}
        })

    },[])
    const height = props?.height ? props.height : "320px"
    //const myUploads = this.context.uploads.filter(model => model.section === this.state.section.name)
    const collection = mortgageContext.mortgage.uploads.filter(upload => {
        if (section?.index) {
            return upload.section === section.name && upload.state === section.stage && upload.index === section.index
        }
        return upload.section === section.name && upload.stage === section.stage
    }) || []
    if (!section) {
        return <></>
    }
    return (
        <>
        <OutletWrapper back={'..'} title={section.title} onEdit={toggleEdit}
                       editing={state.editing}>
            <DragDrop handleDrop={handleDrop}>
                <div className={`question-transition ${state.position}`} style={{overflowY: "auto", height: height}}>
                    <table className="table w-100 text-info">
                        <tbody>
                        {
                            collection.map((model, i) => {

                                const fileAttr = state.files.hasOwnProperty(model.id) && model.status === 'UPLOADING' ? {
                                    file: state.files[model.id],
                                    onComplete: onUploadComplete
                                } : {}
                                return (<UploaderRow setViewing={setViewing}
                                                     handleDelete={handleDelete}
                                                     handleNameChange={handleNameChange}
                                                     key={`upload-${model.id}`}
                                                     editMode={state.editing}
                                                     loopIndex={i}
                                                     {...fileAttr}
                                                     model={model}/>)
                            })
                        }
                        </tbody>
                    </table>
                    {collection.length === 0 && (<p className='text-center'>You haven't uploaded anything yet</p>)}
                </div>
            </DragDrop>
            <div className="d-flex m-4">
                <label
                    className="ml-auto d-inline-flex justify-content-start btn btn-outline-info rounded-circle p-2 cursor-pointer position-relative">
                    <FaPlus size={30}/>
                    <input onChange={handleAdd} id="formFileMultiple" className="position-absolute" type="file"
                           multiple/>

                </label>
            </div>
        </OutletWrapper>
            {
                state.viewing && (
                    <div className="doc-overlay">
                        <div className="py-5 text-right">
                            <div className="d-flex justify-content-end">
                                <button onClick={clearViewing} className="my-1 btn btn-light"><FaTimes/></button>
                            </div>
                            {
                                state.contentType.includes('image') && (
                                    <img width={"100%"} src={state.viewing}/>
                                )
                            }
                            {
                                !state.contentType.includes('image') && (
                                    <iframe width={"100%"} src={state.viewing}/>
                                )
                            }

                        </div>
                    </div>)
            }
        </>
    )
}

export default Upload;